import styled from 'styled-components';

import { BadgeAppearance } from './Badge';

import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';

export const StyledBadge = styled.span`
  min-height: 20px;
  min-width: 75px;
  border-radius: 3px;
  padding: 2px 10px;
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XXS};
  font-weight: ${FontWeight.BLACK};
  letter-spacing: 1px;
  line-height: 14px;
  text-transform: uppercase;
  color: ${({ color }) => color};
  border: ${({ appearance, color }) =>
    appearance === BadgeAppearance.OUTLINE ? `1px solid ${color}` : 'none'};
`;
